import { Tag, message, Layout, ConfigProvider, Breadcrumb, Spin, Table, DatePicker, Select, Button, Form, Col, Row, Input, Card, Drawer, Tabs, Descriptions, Dropdown, Menu } from 'antd';
import MedicalSchemaMedications from '../../components/MedicalSchemaMedications';
import MedicalSchemaHistory from '../../components/MedicalSchemaHistory';
import MedicationIntakes from '../../components/MedicationIntakes';
import HospitalizationMedicalSchemas from '../../components/HospitalizationMedicalSchemas';
import HospitalizationProfessionals from '../../components/HospitalizationProfessionals';
import PatientProgress from '../../components/PatientProgress';
import VGIContainer from '../../components/VGI';
import esES from 'antd/lib/locale/es_ES';
import React, { useState, useEffect } from 'react';
import reqwest from 'reqwest';
import moment from 'moment';
import 'antd/dist/antd.css';
import './index.css';
import MyMenu from '../../components/Menu';
import { getToken } from '../../Utils/common';
import { useHistory } from "react-router-dom";
import config from '../../config';

const { Content, Sider } = Layout;
const { Option } = Select;
const { TabPane } = Tabs;

moment.locale('es');

function Hospitalizations() {
  const [active, setActive] = useState(0);
  const history = useHistory();
  const [collapsed, setCollapsed] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  // Default to Active hospitalizations
  const [filters, setFilters] = useState('&status=A');
  const [professionalOptions, setProfessionalOptions] = useState([]);
  const [professionalFilter, setProfessionalFilter] = useState(undefined);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  });

  // Local filter controls (apply on button click)
  const [searchName, setSearchName] = useState('');
  const [statusFilter, setStatusFilter] = useState(undefined);
  const [floorFilter, setFloorFilter] = useState('');
  // Form to capture latest filter values without relying on async state flush
  const [filterForm] = Form.useForm();

  // State for hospitalization form
  const [formVisible, setFormVisible] = useState(false);
  const [formLoading, setFormLoading] = useState(false);
  const [patients, setPatients] = useState([]);
  const [patientOptions, setPatientOptions] = useState([]);
  const [searchingPatients, setSearchingPatients] = useState(false);
  const [hospitalizationForm] = Form.useForm();

  // State for details drawer
  const [detailVisible, setDetailVisible] = useState(false);
  const [selectedHospitalization, setSelectedHospitalization] = useState(null);
  const [hospitalizationSummary, setHospitalizationSummary] = useState(null);
  const [summaryLoading, setSummaryLoading] = useState(false);
  const [detailSaving, setDetailSaving] = useState(false);
  const [detailForm] = Form.useForm();
  const [activeDetailTab, setActiveDetailTab] = useState('datos');

  const isReadOnly = selectedHospitalization && (selectedHospitalization.status !== 'A' || selectedHospitalization.pacient_status === 'S');
  const [schemaLoading, setSchemaLoading] = useState(false);
  const [medicalSchema, setMedicalSchema] = useState(null);
  const [schemaRefresh, setSchemaRefresh] = useState(0);
  const [historyRefresh, setHistoryRefresh] = useState(0);
  const [professionalsRefresh, setProfessionalsRefresh] = useState(0);
  const [intakesRefresh, setIntakesRefresh] = useState(0);

  // Status filter options
  const statusOptions = [
    { text: 'Activo', value: 'A' },
    { text: 'Alta Médica', value: 'M' },
    { text: 'Traslado Clinico', value: 'T' },
    { text: 'Óbito', value: 'O' },
    { text: 'Alta Voluntaria', value: 'V' },
    { text: 'Fuga', value: 'F' },
    { text: 'Baja Residente', value: 'BP' },
    { text: 'Residente Inactivo', value: 'PI' },
  ];


  useEffect(() => {
    // Load only Active hospitalizations by default
    loadHospitalizations({ pagination, extraQuery: filters });
  }, []);

  // Load assigned professionals for filter dropdown
  useEffect(() => {
    reqwest({
      url: `${config.api_url}/hospitalization/assigned_professionals/`,
      method: 'get',
      type: 'json',
      headers: { 'Authorization': `Token ${getToken()}` },
    }).then(resp => {
      const list = Array.isArray(resp) ? resp : (resp.results || []);
      setProfessionalOptions(list);
    }).catch(() => setProfessionalOptions([]));
  }, []);

  // Handle table change (pagination, filters, sorter)
  const [lastTableFilters, setLastTableFilters] = useState({});
  const [lastSorter, setLastSorter] = useState(null);

  const handleTableChange = (pagination, tableFilters, sorter) => {
    // keep last filters/sorter to reuse for export
    setLastTableFilters(tableFilters || {});
    setLastSorter(sorter || null);
    loadHospitalizations({
      pagination,
      filters: tableFilters,
      sorter,
      // Preserve custom filter query string across pagination/sorting
      extraQuery: filters,
    });
  };

  // Fetch hospitalizations data from the API
  const loadHospitalizations = (params = {}) => {
    setLoading(true);

    // Build the query parameters
    let queryParams = '';

    // Add pagination (DRF uses LimitOffsetPagination: limit + offset)
    if (params.pagination) {
      const { current = 1, pageSize = 10 } = params.pagination;
      const offset = current > 1 ? pageSize * (current - 1) : 0;
      queryParams += `&limit=${pageSize}&offset=${offset}`;
    }

    // Add filters
    if (params.filters) {
      // params.filters can come from AntD Table (object) or our custom string.
      // When from Table, keys will match column dataIndex (e.g., status_display).
      // Support both display keys and raw field keys.
      const f = params.filters;

      // Status filter (supports both 'status' and 'status_display' keys)
      const statusValues = (f.status || f.status_display);
      if (Array.isArray(statusValues) && statusValues.length > 0) {
        queryParams += `&status=${statusValues.join(',')}`;
      }

    }

    // Add sorting
    if (params.sorter && params.sorter.field) {
      const order = params.sorter.order === 'descend' ? '-' : '';
      let field = params.sorter.field;
      if (field === 'pacient_last_name') field = 'pacient__last_name';
      if (field === 'pacient_name') field = 'pacient__name';
      queryParams += `&ordering=${order}${field}`;
    }

    // Add any additional filters (custom query string from form)
    if (params.extraQuery) {
      queryParams += params.extraQuery;
    }

    // Make the API request
    reqwest({
      url: `${config.api_url}/hospitalization/?${queryParams.substring(1)}`,
      method: 'get',
      type: 'json',
      headers: {
        'Authorization': `Token ${getToken()}`,
      },
    }).then(response => {
      setLoading(false);

      // Update the data and pagination
      setData(response.results);
      setPagination({
        ...params.pagination,
        total: response.count,
      });
    }).catch(error => {
      setLoading(false);

      // Handle authentication errors
      if (error.status === 401) {
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('user');
        history.push('/login');
      } else {
        message.error(`Error al cargar las internaciones: ${error.status}`);
      }
    });
  };

  // New: apply filters only when user clicks a button (Form submit guarantees freshest values)
  const onFilterSubmit = (values) => {
    const currentSearch = values && values.searchName != null ? String(values.searchName) : '';
    const currentStatus = values && values.statusFilter !== undefined ? values.statusFilter : undefined;
    const currentFloor = values && values.floorFilter !== undefined ? values.floorFilter : '';
    const currentProfessional = values && values.professionalFilter !== undefined ? values.professionalFilter : undefined;

    let qs = '';
    if (currentSearch && String(currentSearch).trim()) {
      qs += `&search=${encodeURIComponent(String(currentSearch).trim())}`;
    }
    if (currentStatus) {
      qs += `&status=${encodeURIComponent(currentStatus)}`;
    }
    if (currentFloor !== '' && currentFloor !== null && currentFloor !== undefined) {
      qs += `&floor=${encodeURIComponent(currentFloor)}`;
    }
    if (currentProfessional) {
      qs += `&professional_id=${encodeURIComponent(currentProfessional)}`;
    }

    setFilters(qs);
    // Reset to first page when applying new filters
    const pag = { ...pagination, current: 1 };
    setPagination(pag);
    // Important: pass custom filters via extraQuery to avoid clashing with Table filters parser
    loadHospitalizations({ pagination: pag, extraQuery: qs });
  };

  // Build export query by combining form filters (filters state), last table filters and sorter
  const buildExportQuery = () => {
    let qs = filters || '';

    // Merge status filter coming from table header (status_display or status)
    const tableStatus = (lastTableFilters && (lastTableFilters.status || lastTableFilters.status_display)) || undefined;
    if (Array.isArray(tableStatus) && tableStatus.length > 0) {
      // If filters string already has status, merge values, else append
      const hasStatus = /(^|&)status=/.test(qs);
      const values = tableStatus.join(',');
      if (hasStatus) {
        // naive merge: append additional values if not duplicated
        // Extract existing value
        try {
          const urlSearch = new URLSearchParams(qs.replace(/^&/, ''));
          const existing = urlSearch.get('status');
          if (existing) {
            const set = new Set((existing.split(',').concat(tableStatus)).map(String));
            urlSearch.set('status', Array.from(set).join(','));
          } else {
            urlSearch.set('status', values);
          }
          qs = '&' + urlSearch.toString();
        } catch (e) {
          // Fallback: just append
          qs += `&status=${encodeURIComponent(values)}`;
        }
      } else {
        qs += `&status=${encodeURIComponent(values)}`;
      }
    }

    // Add ordering from lastSorter (DRF OrderingFilter expects ordering=field or -field)
    if (lastSorter && lastSorter.field) {
      const order = lastSorter.order === 'descend' ? '-' : '';
      let field = lastSorter.field;
      if (field === 'pacient_last_name') field = 'pacient__last_name';
      if (field === 'pacient_name') field = 'pacient__name';
      qs += `&ordering=${order}${field}`;
    }

    // Ensure leading ? assembly caller uses substring(1)
    return qs;
  };

  const [exporting, setExporting] = useState(false);
  const exportHospitalizations = async () => {
    try {
      setExporting(true);
      const qs = buildExportQuery();
      const url = `${config.api_url}/hospitalization/export/?${qs.startsWith('&') ? qs.substring(1) : qs}`;
      const resp = await window.fetch(url, {
        method: 'GET',
        headers: { 'Authorization': `Token ${getToken()}` },
      });
      if (!resp.ok) {
        // Try extract text error
        const text = await resp.text();
        throw new Error(text || `Error HTTP ${resp.status}`);
      }
      const blob = await resp.blob();
      // Create a temporary anchor to download the file
      const urlBlob = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = urlBlob;
      a.download = 'internaciones.pdf';
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(urlBlob);
    } catch (err) {
      const msg = (err && err.message) ? err.message : 'No se pudo descargar el PDF';
      message.error(msg);
    } finally {
      setExporting(false);
    }
  };

  const [exportingSchemas, setExportingSchemas] = useState(false);
  const exportActiveSchemas = async () => {
    try {
      setExportingSchemas(true);
      const qs = buildExportQuery();
      const url = `${config.api_url}/hospitalization/export_schemas/?${qs.startsWith('&') ? qs.substring(1) : qs}`;
      const resp = await window.fetch(url, {
        method: 'GET',
        headers: { 'Authorization': `Token ${getToken()}` },
      });
      if (!resp.ok) {
        const text = await resp.text();
        throw new Error(text || `Error HTTP ${resp.status}`);
      }
      const html = await resp.text();
      const printHtml = html.replace('</body>', '<script>window.addEventListener("load", function(){ window.print(); });<\/script></body>');
      const blob = new Blob([printHtml], { type: 'text/html' });
      const blobUrl = window.URL.createObjectURL(blob);
      window.open(blobUrl, '_blank');
    } catch (err) {
      const msg = (err && err.message) ? err.message : 'No se pudo exportar los esquemas activos';
      message.error(msg);
    } finally {
      setExportingSchemas(false);
    }
  };

  // Dropdown menu for export actions
  const exportMenu = (
    <Menu
      onClick={({ key }) => {
        if (key === 'hospitalizations') return exportHospitalizations();
        if (key === 'schemas') return exportActiveSchemas();
      }}
    >
      <Menu.Item key="hospitalizations" disabled={exporting}>Internaciones (PDF)</Menu.Item>
      <Menu.Item key="schemas" disabled={exportingSchemas}>Esquemas activos (Imprimir)</Menu.Item>
    </Menu>
  );

  // Clear all filters and reload unfiltered list
  const onClearFilters = () => {
    // Reset form inputs
    filterForm.resetFields();
    // Clear stored extra query
    setFilters('');
    // Reset pagination to first page
    const pag = { ...pagination, current: 1 };
    setPagination(pag);
    // Fetch without extraQuery to get all results
    loadHospitalizations({ pagination: pag, extraQuery: '' });
  };

  // Keep handlers to update local state only
  const handleStatusFilterChange = (value) => {
    setStatusFilter(value);
  };

  const handleSearch = (value) => {
    setSearchName(value);
  };

  // Search patients for the form dropdown
  const searchPatients = (searchText) => {
    if (!searchText) {
      setPatientOptions([]);
      return;
    }

    setSearchingPatients(true);

    reqwest({
      url: `${config.api_url}/pacients/?search=${searchText}&limit=10`,
      method: 'get',
      type: 'json',
      headers: {
        'Authorization': `Token ${getToken()}`,
      },
    }).then(response => {
      setSearchingPatients(false);

      // Format patient options for the dropdown
      const options = response.results.map(patient => ({
        value: patient.id,
        label: `${patient.name} ${patient.last_name} (${patient.document})`,
        patient: patient
      }));

      setPatientOptions(options);
    }).catch(error => {
      setSearchingPatients(false);

      // Handle authentication errors
      if (error.status === 401) {
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('user');
        history.push('/login');
      } else {
        message.error(`Error al buscar residentes: ${error.status}`);
      }
    });
  };

  // Create a new medical schema
  const createMedicalSchema = () => {
    return new Promise((resolve, reject) => {
      reqwest({
        url: `${config.api_url}/medicalschema/`,
        method: 'post',
        type: 'json',
        data: {},  // No data needed, backend will set created_at automatically
        headers: {
          'Authorization': `Token ${getToken()}`,
        },
      }).then(response => {
        resolve(response);
      }).catch(error => {
        // Handle authentication errors
        if (error.status === 401) {
          sessionStorage.removeItem('token');
          sessionStorage.removeItem('user');
          history.push('/login');
        }
        reject(error);
      });
    });
  };

  // Helper to extract a detailed error message from reqwest error
  const extractErrorMessage = (error, defaultMsg) => {
    try {
      // Prefer JSON payload if present
      const resp = error && (error.responseJSON || error.response || error.responseText || error.raw);
      let data = resp;
      if (typeof resp === 'string') {
        try { data = JSON.parse(resp); } catch (e) { /* ignore */ }
      }
      if (data && typeof data === 'object') {
        // Common DRF validation error formats
        // e.g., {status: "msg"} or {status: ["msg"]} or {non_field_errors: ["msg"]}
        const fieldsPriority = ['status', 'non_field_errors', 'detail', 'error'];
        for (const key of fieldsPriority) {
          if (key in data) {
            const val = data[key];
            if (Array.isArray(val)) return val.join(' ');
            if (typeof val === 'string') return val;
          }
        }
        // Otherwise, join first field's messages
        const firstKey = Object.keys(data)[0];
        if (firstKey) {
          const val = data[firstKey];
          if (Array.isArray(val)) return val.join(' ');
          if (typeof val === 'string') return val;
        }
      }
    } catch (e) {
      // ignore parsing errors
    }
    return defaultMsg;
  };

  // Create a new hospitalization
  const createHospitalization = async (values) => {
    setFormLoading(true);

    try {
      // Validate pacient value
      const pacientId = Number(values.pacient);
      if (!pacientId || Number.isNaN(pacientId)) {
        setFormLoading(false);
        message.error('Debe seleccionar un residente válido');
        return;
      }

      // Create the hospitalization without automatically creating a medical schema
      const hospitalizationData = {
        pacient: pacientId,
        status: 'A', // Activo por defecto
        floor: values.floor != null && values.floor !== '' ? values.floor : null,
        room: values.room != null && values.room !== '' ? Number(values.room) : null,
      };

      reqwest({
        url: `${config.api_url}/hospitalization/`,
        method: 'post',
        type: 'json',
        data: hospitalizationData,
        headers: {
          'Authorization': `Token ${getToken()}`,
        },
      }).then(response => {
        setFormLoading(false);
        setFormVisible(false);
        hospitalizationForm.resetFields();

        // Show success message
        message.success('Internación creada exitosamente');

        // Refresh the hospitalizations list
        loadHospitalizations({ pagination, extraQuery: filters });
      }).catch(error => {
        setFormLoading(false);

        // Handle authentication errors
        if (error.status === 401) {
          sessionStorage.removeItem('token');
          sessionStorage.removeItem('user');
          history.push('/login');
        } else {
          const detail = extractErrorMessage(error, `Error al crear la internación: ${error.status || ''}`);
          message.error(detail);
        }
      });
    } catch (error) {
      setFormLoading(false);
      message.error(`Error al crear la internación: ${error.status}`);
    }
  };

  // Define table columns
  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      sorter: true,
      width: '5%',
    },
    {
      title: 'Apellido',
      dataIndex: 'pacient_last_name',
      sorter: true,
      width: '12%',
    },
    {
      title: 'Nombre',
      dataIndex: 'pacient_name',
      sorter: true,
      width: '12%',
    },
    {
      title: 'Piso',
      dataIndex: 'floor',
      sorter: true,
      width: '8%',
      render: (v) => (v != null && v !== '') ? v : '-',
    },
    {
      title: 'Habitación',
      dataIndex: 'room',
      sorter: true,
      width: '8%',
      render: (v) => (v != null && v !== '') ? v : '-',
    },
    {
      title: 'Estado',
      dataIndex: 'status_display',
      filters: statusOptions,
      width: '10%',
      render: (status, record) => {
        let color = 'green';
        switch (record.status) {
          case 'A':
            color = 'green'; // Activo
            break;
          case 'M':
            color = 'blue'; // Alta Médica
            break;
          case 'T':
            color = 'orange'; // Traslado Clinico
            break;
          case 'O':
            color = 'red'; // Óbito
            break;
          case 'V':
            color = 'purple'; // Alta Voluntaria
            break;
          case 'F':
            color = 'volcano'; // Fuga
            break;
          case 'BP':
            color = 'cyan'; // Baja Residente
            break;
          case 'PI':
            color = 'geekblue'; // Residente Inactivo
            break;
          case 'ST':
            color = 'gold'; // Salida Temporal
            break;
          default:
            color = 'default';
        }
        return <Tag color={color}>{status}</Tag>;
      },
    },
    {
      title: 'Fecha de creación',
      dataIndex: 'created_at',
      sorter: true,
      width: '14%',
      render: date => (date ? moment(date).format('DD/MM/YYYY HH:mm') : '-'),
    },
    {
      title: 'Última actualización',
      dataIndex: 'updated_at',
      sorter: true,
      width: '14%',
      render: date => (date ? moment(date).format('DD/MM/YYYY HH:mm') : '-'),
    },
    {
      title: 'Creado por',
      dataIndex: 'created_by_username',
      width: '10%',
      render: (v, record) => (v && String(v).trim()) ? v : '-',
    },
    {
      title: 'Actualizado por',
      dataIndex: 'updated_by_username',
      width: '12%',
      render: (v, record) => (v && String(v).trim()) ? v : '-',
    },
    {
      title: 'Fecha de finalización',
      dataIndex: 'ended_at',
      sorter: true,
      width: '13%',
      render: date => date ? moment(date).format('DD/MM/YYYY HH:mm') : '-',
    },
  ];

  const fetchMedicalSchema = (schemaId) => {
    if (!schemaId) return;
    setSchemaLoading(true);
    reqwest({
      url: `${config.api_url}/medicalschema/${schemaId}/`,
      method: 'get',
      type: 'json',
      headers: {
        'Authorization': `Token ${getToken()}`,
      },
    }).then(response => {
      setMedicalSchema(response);
      setSchemaLoading(false);
    }).catch(error => {
      setSchemaLoading(false);
      if (error.status === 401) {
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('user');
        history.push('/login');
      } else {
        message.error(`Error al cargar el esquema médico: ${error.status}`);
      }
    });
  };

  const openDetail = (record) => {
    setSelectedHospitalization(record);
    setDetailVisible(true);
    setActiveDetailTab('datos');
    // initialize form values
    detailForm.setFieldsValue({
      status: record.status || undefined,
      floor: record.floor != null ? record.floor : undefined,
      room: record.room != null ? record.room : undefined,
      bed: record.bed != null ? record.bed : undefined,
    });
    // prefetch summary and schema
    fetchHospitalizationSummary(record.id);
    fetchMedicalSchema(record.medical_schema);
  };

  const closeDetail = () => {
    setDetailVisible(false);
    setSelectedHospitalization(null);
    setHospitalizationSummary(null);
    setMedicalSchema(null);
  };

  const fetchHospitalizationDetail = (id) => {
    if (!id) return;
    fetchHospitalizationSummary(id);
    reqwest({
      url: `${config.api_url}/hospitalization/${id}/`,
      method: 'get',
      type: 'json',
      headers: { 'Authorization': `Token ${getToken()}` },
    }).then(resp => {
      // Update drawer selected and table list item if present
      setSelectedHospitalization(resp);
      setData(prev => Array.isArray(prev) ? prev.map(it => it.id === resp.id ? resp : it) : prev);
      // Also keep form values in sync
      detailForm.setFieldsValue({
        status: resp.status || undefined,
        floor: resp.floor != null ? resp.floor : undefined,
        room: resp.room != null ? resp.room : undefined,
        bed: resp.bed != null ? resp.bed : undefined,
      });
    }).catch(() => {
      // Silent fail in drawer context to avoid noise
    });
  };

  const fetchHospitalizationSummary = (id) => {
    if (!id) return;
    setSummaryLoading(true);
    reqwest({
      url: `${config.api_url}/hospitalization/${id}/summary/`,
      method: 'get',
      type: 'json',
      headers: { 'Authorization': `Token ${getToken()}` },
    }).then(resp => {
      setHospitalizationSummary(resp);
      setSummaryLoading(false);
    }).catch(() => {
      setSummaryLoading(false);
    });
  };

  const saveDetail = () => {
    if (!selectedHospitalization) return;
    detailForm.validateFields().then(values => {
      setDetailSaving(true);
      reqwest({
        url: `${config.api_url}/hospitalization/${selectedHospitalization.id}/`,
        method: 'patch',
        type: 'json',
        data: {
          status: values.status,
          floor: values.floor != null && values.floor !== '' ? values.floor : null,
          room: values.room != null && values.room !== '' ? Number(values.room) : null,
        },
        headers: {
          'Authorization': `Token ${getToken()}`,
        },
      }).then(response => {
        setDetailSaving(false);
        // Update drawer and table data
        setSelectedHospitalization(response);
        detailForm.setFieldsValue({ status: response.status, floor: response.floor != null ? response.floor : undefined, room: response.room != null ? response.room : undefined });
        setData(prev => prev.map(item => item.id === response.id ? response : item));
        message.success('Internación actualizada');
      }).catch(error => {
        setDetailSaving(false);
        if (error.status === 401) {
          sessionStorage.removeItem('token');
          sessionStorage.removeItem('user');
          history.push('/login');
        } else {
          const detail = extractErrorMessage(error, `Error al actualizar la internación: ${error.status || ''}`);
          message.error(detail);
        }
      });
    });
  };

  return (
    <ConfigProvider locale={esES}>
      <Layout style={{ minHeight: '100vh' }}>
        <Sider collapsible collapsed={collapsed} onCollapse={setCollapsed} className="no-print">
          <div className="logo" />
          <MyMenu  active={active} />
        </Sider>
        <Layout className="site-layout">
          <Content style={{ margin: '0 16px' }}>
            <Breadcrumb style={{ margin: '16px 0' }}>
              <Breadcrumb.Item>Home</Breadcrumb.Item>
              <Breadcrumb.Item>Internaciones</Breadcrumb.Item>
            </Breadcrumb>
            <div className="site-layout-background" style={{ padding: 24, minHeight: 360 }}>
              <Card title="Listado de Internaciones" bordered={false}>
                <Form form={filterForm} layout="vertical" onFinish={onFilterSubmit} initialValues={{ statusFilter: 'A' }}>
                  <Row gutter={16}>
                    <Col span={6}>
                      <Form.Item name="searchName" label={false} style={{ marginBottom: 0 }}>
                        <Input
                          placeholder="Buscar por nombre de residente"
                          style={{ width: '100%' }}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={6}>
                      <Form.Item name="statusFilter" label={false} style={{ marginBottom: 0 }}>
                        <Select
                          placeholder="Filtrar por estado"
                          style={{ width: '100%' }}
                          allowClear
                        >
                          {statusOptions.map(option => (
                            <Option key={option.value} value={option.value}>{option.text}</Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col span={6}>
                      <Form.Item name="floorFilter" label={false} style={{ marginBottom: 0 }}>
                        <Input
                          placeholder="Piso"
                          style={{ width: '100%' }}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={6}>
                      <Form.Item name="professionalFilter" label={false} style={{ marginBottom: 0 }}>
                        <Select
                          placeholder="Profesional asignado"
                          style={{ width: '100%' }}
                          allowClear
                          showSearch
                          optionFilterProp="label"
                        >
                          {professionalOptions.map(opt => (
                            <Option key={opt.id} value={opt.id} label={opt.label}>{opt.label}</Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={24}>
                      <div className="filters-actions" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 8 }}>
                        <div>
                          <Button type="primary" onClick={() => setFormVisible(true)}>
                            Nueva Internación
                          </Button>
                        </div>
                        <div>
                          <Button htmlType="submit">Filtrar</Button>
                          <Button onClick={onClearFilters} style={{ marginLeft: 8 }}>Limpiar</Button>
                          <Dropdown overlay={exportMenu} placement="bottomRight" trigger={["click"]}>
                            <Button style={{ marginLeft: 8 }}>
                              Descargar
                            </Button>
                          </Dropdown>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Form>

                <Spin spinning={loading}>
                  <Table
                    columns={columns}
                    rowKey={record => record.id}
                    dataSource={data}
                    pagination={pagination}
                    loading={loading}
                    onChange={handleTableChange}
                    onRow={(record) => ({
                      onClick: () => openDetail(record),
                      style: { cursor: 'pointer' }
                    })}
                  />
                </Spin>
              </Card>
            </div>
          </Content>
        </Layout>
      </Layout>

      {/* Drawer form for creating a new hospitalization */}
      <Drawer
        title="Nueva Internación"
        width={"60%"}
        visible={formVisible}
        onClose={() => { setFormVisible(false); hospitalizationForm.resetFields(); }}
        destroyOnClose={true}
        footer={
          <div style={{ textAlign: 'right' }}>
            <Button onClick={() => { setFormVisible(false); hospitalizationForm.resetFields(); }} style={{ marginRight: 8 }}>
              Cancelar
            </Button>
            <Button type="primary" onClick={() => hospitalizationForm.submit()} loading={formLoading}>
              Crear
            </Button>
          </div>
        }
      >
        <Form
          form={hospitalizationForm}
          layout="vertical"
          onFinish={createHospitalization}
        >
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="pacient"
                label="Residente"
                rules={[{ required: true, message: 'Por favor seleccione un residente' }]}
              >
                <Select
                  showSearch
                  placeholder="Buscar residente por nombre o documento"
                  filterOption={false}
                  onSearch={searchPatients}
                  notFoundContent={searchingPatients ? <Spin size="small" /> : "No se encontraron residentes"}
                  style={{ width: '100%' }}
                >
                  {patientOptions.map(opt => (
                    <Option key={opt.value} value={opt.value}>{opt.label}</Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item name="floor" label="Piso">
                <Input placeholder="Ej: PB o 1" />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item name="room" label="Habitación">
                <Input type="number" min={0} placeholder="Ej: 12" />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Drawer>

      {/* Drawer for viewing hospitalization details */}
      <Drawer
        title={`Detalle de internación${selectedHospitalization ? ` #${selectedHospitalization.id}` : ''}`}
        width={"65%"}
        visible={detailVisible}
        onClose={closeDetail}
        destroyOnClose
        footer={selectedHospitalization ? (
          <div style={{ textAlign: 'right' }}>
            <Button onClick={closeDetail} style={{ marginRight: 8 }}>
              Cancelar
            </Button>
            {!isReadOnly && (
              <Button type="primary" loading={detailSaving} onClick={saveDetail}>
                Guardar
              </Button>
            )}
          </div>
        ) : null}
      >
        {selectedHospitalization && (
          <Tabs activeKey={activeDetailTab} onChange={(k) => {
            setActiveDetailTab(k);
            if (!selectedHospitalization) return;
            switch (k) {
              case 'datos':
                fetchHospitalizationDetail(selectedHospitalization.id);
                break;
              case 'esquema':
                fetchMedicalSchema(selectedHospitalization.medical_schema);
                setSchemaRefresh(prev => prev + 1);
                break;
              case 'profesionales':
                setProfessionalsRefresh(prev => prev + 1);
                break;
              case 'tomas':
                setIntakesRefresh(prev => prev + 1);
                break;
              case 'hist_clinica':
                setHistoryRefresh(prev => prev + 1);
                break;
              default:
                break;
            }
          }}>
            <TabPane tab="Datos" key="datos">
              <Form form={detailForm} layout="vertical" initialValues={{
                status: selectedHospitalization.status,
                floor: selectedHospitalization.floor,
                room: selectedHospitalization.room,
                bed: selectedHospitalization.bed,
              }}>
                <Row gutter={16}>
                  <Col span={8}>
                    <Form.Item name="status" label="Estado" rules={[{ required: true, message: 'Seleccione un estado' }]}>
                      <Select disabled={isReadOnly}>
                        {statusOptions.map(option => (
                          <Option key={option.value} value={option.value}>{option.text}</Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item name="floor" label="Piso">
                      <Input placeholder="Ej: PB o 1" disabled={isReadOnly} />
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item name="room" label="Habitación">
                      <Input type="number" min={0} placeholder="Ej: 12" disabled={isReadOnly} />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={16}>
                  <Col span={8}>
                    <Form.Item name="bed" label="Cama">
                      <Input type="number" min={0} placeholder="Ej: 12" disabled={isReadOnly} />
                    </Form.Item>
                  </Col>
                </Row>
              </Form>

              {hospitalizationSummary && hospitalizationSummary.photo && (
                <div style={{ marginBottom: 16, textAlign: 'left' }}>
                  <img 
                    src={hospitalizationSummary.photo} 
                    alt="Foto Residente"
                    style={{ width: 150, height: 150, borderRadius: 8, objectFit: 'cover', border: '1px solid #f0f0f0' }} 
                  />
                </div>
              )}

              <Descriptions bordered column={1} size="small">
                <Descriptions.Item label="ID">{selectedHospitalization.id}</Descriptions.Item>
                <Descriptions.Item label="Estado">{selectedHospitalization.status_display}</Descriptions.Item>
                <Descriptions.Item label="Nombre Completo">
                  <div>{`${selectedHospitalization.pacient_name} ${selectedHospitalization.pacient_last_name}`}</div>
                </Descriptions.Item>
                <Descriptions.Item label="Edad">
                  {summaryLoading ? <Spin size="small" /> : (hospitalizationSummary && hospitalizationSummary.age !== null ? `${hospitalizationSummary.age} años` : '-')}
                </Descriptions.Item>
                <Descriptions.Item label="Diagnóstico Clínico">
                  {summaryLoading ? <Spin size="small" /> : (hospitalizationSummary?.diagnosis_clinical || '-')}
                </Descriptions.Item>
                <Descriptions.Item label="Diagnóstico Psiquiátrico">
                  {summaryLoading ? <Spin size="small" /> : (hospitalizationSummary?.diagnosis_psychiatric || '-')}
                </Descriptions.Item>
                <Descriptions.Item label="Piso">{(selectedHospitalization.floor != null && selectedHospitalization.floor !== '') ? selectedHospitalization.floor : '-'}</Descriptions.Item>
                <Descriptions.Item label="Habitación">{(selectedHospitalization.room != null && selectedHospitalization.room !== '') ? selectedHospitalization.room : '-'}</Descriptions.Item>
                <Descriptions.Item label="Cama">{(selectedHospitalization.bed != null && selectedHospitalization.bed !== '') ? selectedHospitalization.bed : '-'}</Descriptions.Item>
                <Descriptions.Item label="Creado">{moment(selectedHospitalization.created_at).format('DD/MM/YYYY HH:mm')}</Descriptions.Item>
                <Descriptions.Item label="Actualizado">{moment(selectedHospitalization.updated_at).format('DD/MM/YYYY HH:mm')}</Descriptions.Item>
                <Descriptions.Item label="Finalizado">{selectedHospitalization.ended_at ? moment(selectedHospitalization.ended_at).format('DD/MM/YYYY HH:mm') : '-'}</Descriptions.Item>
              </Descriptions>
            </TabPane>
            <TabPane tab="Esquema Médico" key="esquema">
              <HospitalizationMedicalSchemas
                key={`schemas-${selectedHospitalization ? selectedHospitalization.id : 'none'}-${schemaRefresh}`}
                hospitalizationId={selectedHospitalization ? selectedHospitalization.id : null}
                hospitalizationStatus={selectedHospitalization ? selectedHospitalization.status : null}
                activeMedicalSchemaId={selectedHospitalization ? selectedHospitalization.medical_schema : null}
                isReadOnly={isReadOnly}
                onChanged={() => {
                  // refresh hospitalization row after changes if needed
                  setSchemaRefresh(prev => prev + 1);
                }}
              />
            </TabPane>
            <TabPane tab="Profesionales" key="profesionales">
              <HospitalizationProfessionals
                key={`pro-${selectedHospitalization ? selectedHospitalization.id : 'none'}-${professionalsRefresh}`}
                hospitalizationId={selectedHospitalization ? selectedHospitalization.id : null}
                hospitalizationStatus={selectedHospitalization ? selectedHospitalization.status : null}
                isReadOnly={isReadOnly}
              />
            </TabPane>
            <TabPane tab="Adm. de Medicación" key="tomas">
              <MedicationIntakes
                key={`intakes-${selectedHospitalization ? selectedHospitalization.id : 'none'}-${intakesRefresh}`}
                hospitalizationId={selectedHospitalization ? selectedHospitalization.id : null}
                hospitalizationStatus={selectedHospitalization ? selectedHospitalization.status : null}
                medicalSchemaId={selectedHospitalization ? selectedHospitalization.medical_schema : null}
                isReadOnly={isReadOnly}
              />
            </TabPane>
            <TabPane tab="VGI" key="vgi">
              <VGIContainer 
                pacientId={selectedHospitalization ? selectedHospitalization.pacient : null} 
                hospitalizationStatus={selectedHospitalization ? selectedHospitalization.status : null}
                isReadOnly={isReadOnly}
              />
            </TabPane>
            <TabPane tab="Hist. Clínica" key="hist_clinica">
              <PatientProgress 
                key={`hist-${selectedHospitalization ? selectedHospitalization.pacient : 'no-patient'}-${historyRefresh}`} 
                patient_id={selectedHospitalization ? selectedHospitalization.pacient : null} 
                isReadOnly={isReadOnly}
              />
            </TabPane>
          </Tabs>
        )}
      </Drawer>
    </ConfigProvider>
  );
}

export default Hospitalizations;
